import { combineReducers } from 'redux';
import AuthReducer from './AuthReducers';
import SessionReducer from './SessionReducer';

export default combineReducers({
  auths: AuthReducer,
  sessionManager: SessionReducer,
});
